export const Errors = {
    NoAppAccess: "NO_APP_ACCESS",
    NoCCUser: "NO_CC_USER",
    MissingInvite: "REQUIRES_INVITE",
};